module.exports = __webpack_public_path__ + "static/pains-568a5720d36b3d5c5bc16f696419aa96.gif";